module Elma.Bindings {
    interface ICloseMenuItemsArgs {
        menuOpenObservable: KnockoutObservable<boolean>,
        miniCartVisibleObservable: KnockoutObservable<boolean>
        itemCssClass?: string,
        menuCssClass?: string,
        backdropClass?: string,
        setSubMenuClass?: string
    }
    export class CloseMenuItems {
        public init(element: any, valueAccessor: () => ICloseMenuItemsArgs, allBindingsAccessor?: KnockoutAllBindingsAccessor, viewModel?: any, bindingContext?: KnockoutBindingContext) {
            if (!bindingContext) {
                return;
            }
            var logger = Ftw.Base.Config.Logger;
            var settings = ko.unwrap(valueAccessor());

            if (settings) {

                var itemCssClass = typeof settings.itemCssClass != "undefined" ? settings.itemCssClass : ".item";
                var menuCssClass = typeof settings.itemCssClass != "undefined" ? settings.menuCssClass : ".menu";
                var setSubMenuClass = typeof settings.setSubMenuClass != "undefined" ? settings.setSubMenuClass : ".setSubmenu";
                var backdropClass = typeof settings.backdropClass != "undefined" ? settings.backdropClass : ".js-backdrop";

                if (ko.observable(settings.miniCartVisibleObservable) && ko.observable(settings.menuOpenObservable)) {

                    var menuOpen = settings.menuOpenObservable;
                    var miniCartVisible = settings.miniCartVisibleObservable;

                    ko.utils.registerEventHandler(element, "click", function (e) {
                        if (menuOpen()) {
                            $(itemCssClass + ".visible").removeClass('visible');
                            let $menuCssClass = $(menuCssClass + ".visible");
                            $menuCssClass.find(setSubMenuClass).hide();
                            $menuCssClass.removeClass('visible');
                            menuOpen(false);
                            miniCartVisible(false);
                            $(backdropClass).hide();
                        }


                    });
                }
                else {
                    logger.warning("closeMenuItems: miniCartVisibleObservable and menuOpenObservable observables expected");
                }
            }
            else {
                logger.warning("closeMenuItems: missing parameters;");
            }
        }
    }
    ko.bindingHandlers['closeMenuItems'] = new CloseMenuItems();
} 
